import { render, staticRenderFns } from "./deviceManager.vue?vue&type=template&id=2cb96bc8&scoped=true"
import script from "./deviceManager.vue?vue&type=script&lang=js"
export * from "./deviceManager.vue?vue&type=script&lang=js"
import style0 from "./deviceManager.vue?vue&type=style&index=0&id=2cb96bc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb96bc8",
  null
  
)

export default component.exports